import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Table,
  Card,
  Container,
  Row,
  Col,
  Modal,
  Spinner,
  Pagination,
} from "react-bootstrap";
import "../../css/admin/adminCreateUser.css";
import "../../css/sweetMsg.css";
import AdminScreenHeader from "./adminScreenHeader";
import { BsPlus } from "react-icons/bs";
import { apiPost } from "../../service/admin/apiService";
import { showSuccess, showError } from "../../utils/toast";
import Loader from "../loader";
import { FaTrash, FaEdit } from "react-icons/fa";
import Swal from "sweetalert2";

export default function UserManagement() {
  const [fn, setFn] = useState("");
  const [ln, setLn] = useState("");
  const [un, setUn] = useState("");
  const [pa, setPa] = useState("");
  const [ui, setUi] = useState(0);
  const [editingIndex, setEditingIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const tk = localStorage.getItem("tk") || "";

  const filteredUsers = userList.filter((user) => {
    const fullName = `${user.fn} ${user.ln}`.toLowerCase();
    const term = searchTerm.toLowerCase();
    return (
      user.un.toLowerCase().includes(term) ||
      user.fn.toLowerCase().includes(term) ||
      user.ln.toLowerCase().includes(term) ||
      fullName.includes(term)
    );
  });

  useEffect(() => {
    getUserList();
  }, []);

  useEffect(() => {
    const calculatedMaxPage = Math.ceil(filteredUsers.length / limit) || 1;
    setMaxPage(calculatedMaxPage);
    if (activePage > calculatedMaxPage) setActivePage(1);
  }, [filteredUsers, limit]);

  const getUserList = async () => {
    const payload = {
      action: "userlist",
      to: tk,
      ui: "",
    };
    if (tk && tk !== "") {
      try {
        setShowLoader(true);
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);
        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
        } else if (response?.responsedetails) {
          setUserList(response?.responsedetails || []);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
      } finally {
        setShowLoader(false);
      }
    }
  };

  const handleEdit = (ui) => {
    const userToEdit = userList.find((user) => user.ui === ui);
    if (userToEdit) {
      setFn(userToEdit.fn);
      setLn(userToEdit.ln);
      setUn(userToEdit.un);
      setPa(userToEdit.pa || "");
      setUi(userToEdit.ui);
      setEditingIndex(userList.findIndex((user) => user.ui === ui));
      setShowModal(true);
    } else {
      showError("User not found.");
    }
  };

  const handleAdd = () => {
    setFn("");
    setLn("");
    setUn("");
    setPa("");
    setUi("");
    setEditingIndex(null);
    setShowModal(true);
  };

  const manageUser = async (transType) => {
    if (loading || !validateFields()) return;
    const payload = {
      action: transType === "userupdate" ? "userupdate" : "useradd",
      to: tk,
      un,
      pa: pa || "",
      fn,
      ln,
      di: "0",
      ...(transType === "userupdate" && { ui }),
    };
    try {
      setLoading(true);
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
      } else if (response?.responsedetails?.success === "yes") {
        showSuccess(
          transType === "userupdate" ? "User updated!" : "User created!"
        );
        setShowModal(false);
        getUserList();
      }
    } catch (err) {
      console.error("Error:", err);
      showError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const deleteUser = async (ui) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      width: "320px",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "btn btn-sm btn-danger",
        cancelButton: "btn btn-sm btn-secondary",
      },
    });
    if (result.isConfirmed) {
      try {
        const payload = { action: "userdelete", to: tk, ui };
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);
        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
        } else {
          showSuccess("User deleted successfully");
          getUserList();
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
      }
    }
  };

  const validateFields = () => {
    if (!fn.trim() || !ln.trim() || !un.trim() || !pa.trim()) {
      showError("Fields with red asterisk cannot be blank.");
      return false;
    }
    return true;
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > maxPage) return;
    setActivePage(pageNumber);
  };

  return (
    <Container className="mt-4 ">
      {/* Desktop View */}
      <div className="d-none d-md-block mt-3">
        <AdminScreenHeader
          title="📋 All Users"
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          placeholder="Search users..."
          showSearch={true}
        />

        <div
          className="fixed-table"
          style={{ maxHeight: "478px", overflowY: "auto" }}
        >
          <Table
            striped
            bordered
            hover
            responsive
            className="w-100 custom-table text-primary custom-table-form24"
          >
            <thead>
              <tr>
                <th style={{ width: "5%" }}></th>
                <th style={{ width: "25%" }}>User ID</th>
                <th style={{ width: "35%" }}>First Name</th>
                <th style={{ width: "30%" }}>Last Name</th>
                <th style={{ textAlign: "center", width: "5%" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers
                .slice((activePage - 1) * limit, activePage * limit)
                .map((user, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "center" }}>
                      <FaTrash
                        style={{
                          color: "#2c3e50",
                          fontSize: "0.80rem",
                          cursor: "pointer",
                        }}
                        onClick={() => deleteUser(user.ui)}
                      />
                    </td>
                    <td>{user.un}</td>
                    <td>{user.fn}</td>
                    <td>{user.ln}</td>
                    <td style={{ textAlign: "center" }}>
                      <Button
                        variant="link"
                        onClick={() => handleEdit(user.ui)}
                      >
                        <FaEdit
                          style={{ cursor: "pointer", color: "#2c3e50" }}
                        />
                      </Button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
        <Row className="mt-3 mb-3">
          <Col className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <label
                className="me-2 mb-0"
                style={{ color: "#0d6efd", fontSize: "13px" }}
              >
                Records per page:
              </label>
              <Form.Select
                value={limit}
                onChange={(e) => {
                  const value =
                    e.target.value === "All"
                      ? filteredUsers.length
                      : parseInt(e.target.value);
                  setLimit(value);
                  setActivePage(1);
                }}
                style={{ width: "100px" }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100000">All</option>
              </Form.Select>
            </div>

            {/* Pagination */}
            <Pagination className="mb-0">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={activePage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(activePage - 1)}
                disabled={activePage === 1}
              />
              <Pagination.Item>
                {`Page ${activePage} of ${maxPage}`}
              </Pagination.Item>
              <Pagination.Next
                onClick={() => handlePageChange(activePage + 1)}
                disabled={activePage >= maxPage}
              />
              <Pagination.Last
                onClick={() => handlePageChange(maxPage)}
                disabled={activePage >= maxPage}
              />
            </Pagination>

            {/* Create User Button */}
            <div>
              <Button onClick={handleAdd}>
                <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />{" "}
                Create User
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      {/* Mobile View */}
      <div className="d-md-none mobile-view-container">
        <AdminScreenHeader
          title="📋 All Users"
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          placeholder="Search users..."
          showSearch={true}
        />
        <div className="scrollable-card-body">
          {userList
            .filter((user) => {
              const term = searchTerm.toLowerCase();
              return (
                user.fn.toLowerCase().includes(term) ||
                user.ln.toLowerCase().includes(term) ||
                user.un.toLowerCase().includes(term)
              );
            })
            .map((user, index) => (
              <Card key={index} className="mb-2">
                <Card.Body className="card-body">
                  <Card.Title className="mb-1 card-title">
                    {user.fn} {user.ln}
                  </Card.Title>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
                  <Card.Subtitle className="card-subtitle">
                    User ID: {user.un}
                  </Card.Subtitle>

                  <div className="d-flex justify-content-between mt-3">
                    <Button
                      size="sm"
                      variant="light"
                      onClick={() => handleEdit(user.ui)}
                    >
                      Edit
                    </Button>

                    <Button
                      size="sm"
                      variant="light"
                      onClick={() => deleteUser(user.ui)}
                    >
                      <FaTrash
                        style={{
                          color: "#2c3e50",
                        }}
                      />
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            ))}
        </div>

        <div className="d-flex justify-content-end mt-3">
          <Button
            size="sm"
            onClick={() => {
              handleAdd();
            }}
          >
            <BsPlus
              style={{
                color: "#2c3e50",
                fontSize: "1.5rem",
                fontWeight: "bold",
              }}
            />
            Create User
          </Button>
        </div>
      </div>

      {/* Modal for Create/Edit */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header className="custom-header" closeButton>
          <Modal.Title className="text-primary ">
            {editingIndex !== null ? "Edit User" : "Create User"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="textbox-label">
                First Name<span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={fn}
                onChange={(e) => setFn(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Label className="textbox-label">
              Last Name<span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                value={ln}
                onChange={(e) => setLn(e.target.value)}
                label="Last Name"
                required
              />
            </Form.Group>
            <Form.Label className="textbox-label">
              User ID<span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                value={un}
                onChange={(e) => setUn(e.target.value)}
                label="User ID"
                required
              />
            </Form.Group>
            <Form.Label className="textbox-label">
              Password<span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Group className="mb-3">
              <Form.Control
                type="password"
                value={pa}
                onChange={(e) => setPa(e.target.value)}
                label="Password"
                required
              />
            </Form.Group>

            <div className="d-grid">
              <Button
                variant="primary"
                onClick={() => {
                  manageUser(editingIndex !== null ? "userupdate" : "useradd");
                }}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2 " />
                    <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                    {editingIndex !== null ? "Updating..." : "Adding..."}
                  </>
                ) : (
                  <>
                    <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                    {editingIndex !== null ? "Update" : "Add"}
                  </>
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {showLoader ? <Loader show={showLoader} /> : null}
    </Container>
  );
}
